module.exports = __webpack_public_path__ + "static/media/PDF_107.b6102d49.pdf";